import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./RecurPlanDetails.css";
import axios from "axios";

function RecurPlanDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { email_id, subscription_id, crm_sub_id } = location.state || {
    id: "Unknown ID",
    name: "Unknown Name",
  };

  sessionStorage.removeItem("parentPage");

  const [reports, setReports] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");


  const useremail_id = sessionStorage.getItem("userEmail");

  const transaction_id = sessionStorage.getItem("transactionId");

  useEffect(() => {
    // console.log(" dated report:", reports);
  }, [reports]);

  const convertDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  useEffect(() => {
    axios
      .get(`/server/subscription/customer/activeSubscriptionDetail/${useremail_id}/${subscription_id}`)
      .then((response) => {

        const transactionDetails = response.data.data["Subscription_details"];
        const ContactDetails = response.data.data["Contact_details"];

        const Subscription_Amount = transactionDetails.Subscription_Amount;
        const active = transactionDetails.Active ? "Active" : "Not Active";
        const type = transactionDetails.Frequency;
        const optionalProcessing_Fee = transactionDetails.Processing_Fee || 0;
        const Admin_Fee = transactionDetails.Admin_Fee || 0;
        const start_date = convertDate(transactionDetails.Subscription_Start);
        const last_donateDate = convertDate(transactionDetails.Last_Payment_Date);
        const next_donateDate = convertDate(transactionDetails.Next_Payment_Date);
        const card_last4 = ContactDetails.Default_Card_Payment;
        const CRM_contact_id = ContactDetails.CRM_contact_id;
        const isSubscriptionCancelled = transactionDetails.Subscription_Cancelled ? true : false;

        const subscriptionDate = {
          amount: Subscription_Amount != null ? `$${Subscription_Amount.toFixed(2)}` : "",
          status: active,
          sub_id: subscription_id,
          plansType: type,
          OptionalProcessing_Fee: optionalProcessing_Fee != null ? `$${optionalProcessing_Fee.toFixed(2)}` : "",
          Admin_Fee: Admin_Fee != null ? `$${Admin_Fee.toFixed(2)}` : "",
          start_date: start_date,
          last_donateDate: last_donateDate,
          next_donateDate: next_donateDate,
          card_last4: card_last4,
          CRM_contact_id: CRM_contact_id,
          isSubscriptionCancelled: isSubscriptionCancelled,
        };

        setReports(subscriptionDate);

        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching subscription data:", error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`/server/subscription/customer/transactionList/${subscription_id}`)
      .then((response) => {

        const transactionData = response.data.data["Transaction_details"];

        if (!transactionData || transactionData.length === 0) {
          return;
        }

        const transactions = transactionData.map((deal) => {
          const subscriptionDetails = deal.subscription_details || [];
          const frequency = subscriptionDetails.length > 0 ? subscriptionDetails[0].Frequency : "";

          return {
            Transaction_Name: deal.Transaction_Name,
            Transaction_Amount: deal.Total_Amount != null ? `$${deal.Total_Amount.toFixed(2)}` : "",
            PaymentStatus: deal.Payment_Status,
            TransactionDate: convertDate(deal.Transaction_Date),
            transaction_id: deal.CRM_Transaction_id,
            waqfName: deal.Waqf && deal.Waqf.name ? deal.Waqf.name : "",
            Frequency: frequency,
          };
        });

        setSubscriptions(transactions);
      })
      .catch((error) => console.error("Error fetching subscription data:", error))
      .finally(() => setIsLoading(false));
  }, [subscription_id]);

  const handleConfirmCancel = () => {
    setIsLoader(true);
    setResponseMessage("");
    axios
      .post("/server/subscription/payment/cancel", { subscription_id })
      .then((response) => {
        setResponseMessage("Plan cancelled successfully!");
      })
      .catch((error) => {
        console.error("Error canceling payment:", error);
        setResponseMessage("Failed to cancel the plan. Try Again Later!");
      })
      .finally(() => {
        setIsLoader(false);
        setTimeout(() => {
          setShowModal(false);
          setResponseMessage("");
        }, 3000);
      });
  };

  const navigateTO = (email_id, transactionId) => {
    navigate(`/donationDetails`, {
      state: { email_id, transactionId },
    });
  };

  return (
    <div className="bg-[#F7F7F7] -m-[23px] p-[30px] pl-[45px] pr-[45px] min-h-screen flex flex-col no-scrollbar">
      {isLoading && (
        <div className="absolute inset-0 fixed flex h-90vh justify-center items-center bg-white bg-opacity-75 z-50">
          <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
        </div>
      )}

      <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li class="inline-flex items-center">
            <Link to="/subscription" className="ms-1 text-[14px] text-gray-400  md:ms-2 dark:text-gray-400 hover:text-[#0E5C57]">
              Donation
            </Link>
          </li>
          <li aria-current="page">
            <div class="flex items-center">
              <svg
                class="rtl:rotate-180 w-2.5 h-2.5 text-gray-400 mx-1 text-[14px]"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewdiv="0 0 6 10"
              >
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4" />
              </svg>
              <span class="inline-flex items-center text-[14px]  text-gray-400">Recurring plan {crm_sub_id}</span>
            </div>
          </li>
        </ol>
      </nav>

      <div class="flex flex-col max-sm:block">
        <h5 class="font-Jost text-2xl font-medium leading-[36.4px] mb-2 mt-2">Recurring Plan Details</h5>
      </div>

      <div class="bordercolor flex flex-wrap mb-2 mt-2 w-[100%] h-112px max-sm:block">
        <div class=" p-2 max-sm:p-1">
          <div class="RecurPlanCard">
            <div class="p-4 RecurPlanCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
              <h6 class="RecurPlanCardPay">{reports.amount}</h6>
              <p class="RecurPlanCardvalue font-[600]">Donation Amount</p>
            </div>
          </div>
        </div>
        <div class="p-2 max-sm:p-1">
          <div class="RecurPlanCard">
            <div class="p-4 RecurPlanCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
              <h6 class="text-lg font-bold RecurPlanCardPay">{reports.amount}</h6>
              <p class="RecurPlanCardvalue font-[600]">Gross Value</p>
            </div>
          </div>
        </div>
        <div class="p-2 max-sm:p-1">
          <div class="RecurPlanCard">
            <div class="p-4 RecurPlanCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
              <h6 class="text-lg font-bold RecurPlanCardPay">$0.00</h6>
              <p class="RecurPlanCardvalue font-[600]">Grants Distributed YTD</p>
            </div>
          </div>
        </div>
      </div>

      <div class="bordercolor paymentDiv w-[100%]">
        <div>
          <div class="PaymentHeading flex justify-between ">
            <h6 class="PaymentDetails font-bold w-[100%]">Monthly Payment Details</h6>
            {!reports.isSubscriptionCancelled && (
              <button
                class="paymentCancelBtn cursor-pointer w-[110px] max-sm:w-[100%] hover:bg-[#ffeded] visible max-sm:hidden"
                onClick={() => setShowModal(true)}
              >
                Cancel Plan
              </button>
            )}
            {showModal && (
              <div className="fixed inset-0 flex items-center justify-center bg-transparent">
                <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-300 w-[400px] max-sm:w-[300px] text-center">
                  {!isLoader && !responseMessage && (
                    <>
                      <h3 className="text-lg font-medium mb-4">Are you sure you want to cancel the plan?</h3>
                      <div className="flex justify-center gap-4">
                        <button className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400" onClick={() => setShowModal(false)}>
                          No
                        </button>
                        <button className="px-4 py-2 bg-[#0E5C57] text-white rounded hover:bg-[#3c6d6a]" onClick={handleConfirmCancel}>
                          Yes
                        </button>
                      </div>
                    </>
                  )}

                  {isLoader && (
                    <>
                      <div className="loader1  flex justify-center ml-[40%] max-sm:ml-[38%]"></div>
                      <p className="mt-2 text-[#0E5C57] font-medium text-[16px]">Cancelling Plan...</p>
                    </>
                  )}

                  {responseMessage && (
                    <>
                      <p className="mt-2 text-[#0E5C57] font-medium text-[16px]">{responseMessage}</p>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          <div class="grid grid-cols-2 max-sm:grid-cols-1 gap-4 p-4 max-sm:gap-[0]">
            <div class="space-y-3">
              <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft ">Status</p>
                <p class="text-base flex-2   text-[#0E5C57]">{reports.status}</p>
              </div>
              <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1  paymentLeft ">Recurring Plan ID</p>
                <p class="text-base flex-2 paymentRight">{crm_sub_id}</p>
              </div>
              <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft">Type</p>
                <p class="text-base flex-2 paymentRight">{reports.plansType}</p>
              </div>
              <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft">Payment Method</p>
                <p class="text-base flex-2 paymentRight ">{reports.card_last4}</p>
              </div>
              <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft ">Donation Amount</p>
                <p class="text-base flex-2 paymentRight">{reports.amount}</p>
              </div>
              <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1  paymentLeft">Optional Processing Fee</p>
                <p class="text-base flex-2 paymentRight">{reports.OptionalProcessing_Fee}</p>
              </div>
              <div class="flex justify-start items-center gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft">Awqaf Australia Admin Fee</p>
                <p class="text-base flex-2 paymentRight">{reports.Admin_Fee}</p>
              </div>
              {/* <div class="flex justify-start items-center mb-5 gap-[5px] max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
          <p class="text-sm text-gray-500 flex-1 paymentLeft ">Status</p>
          <p class="text-base flex-2 paymentRight"></p>
        </div> */}
            </div>

            <div class="space-y-3">
              <div class="flex justify-start mb-5 items-center gap-[5px] max-sm:gap-[10px] max-sm:flex-col max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft">Start Date</p>
                <p class="text-base flex-3 paymentRight">{reports.start_date}</p>
              </div>
              <div class="flex justify-start mb-5 items-center gap-[5px] max-sm:gap-[10px] max-sm:flex-col max-sm:items-start">
                <p class="text-sm text-gray-500 flex-1 paymentLeft">Last Donation Date</p>
                <p class="text-base flex-3 paymentRight">{reports.last_donateDate}</p>
              </div>
              {reports.status === "Active" && (
                <div class="flex justify-start mb-5 items-center gap-[5px] max-sm:gap-[10px] max-sm:flex-col max-sm:items-start">
                  <p class="text-sm text-gray-500 flex-1 paymentLeft">Next Donation Date</p>
                  <p class="text-base flex-3 paymentRight">{reports.next_donateDate}</p>
                </div>
              )}
            </div>
          </div>
        </div>
        {!reports.isSubscriptionCancelled && (
          <button
            class="paymentCancelBtn cursor-pointer mb-5 w-[110px] ml-4 max-sm:w-[85%] hover:bg-[#ffeded] hidden max-sm:block"
            onClick={() => setShowModal(true)}
          >
            Cancel Plan
          </button>
        )}
      </div>

      {/* <hr className="text-[#D1D1D1] mt-6 max-sm:mt-2" /> */}

      <div className="flex flex-col mb-2 mt-4 max-sm:block">
        <h5 className="font-Jost text-2xl font-medium leading-[36.4px] mb-2">Donation History</h5>
      </div>
      <div className="flex-1 max-h-[calc(100vh-150px)] scrollbar max-sm:block ">
        <div className="flex flex-col gap-[18px]">
          {subscriptions.length > 0 ? (
            subscriptions.map((donation) => (
              <div
                className="flex flex-row justify-center cursor-pointer items-center max-sm:flex-col max-sm:justify-start max-sm:items-start max-sm:block"
                onClick={() => navigateTO(useremail_id, donation.transaction_id)}
              >
                <div className="bg-white rounded-[8px] border-[1px] border-[#0000001A] h-[121px] w-[100%] p-[40px] pr-[32px] pl-[25px] shadow-none max-sm:w-[100%] max-sm:h-[auto] max-sm:p-[20px]">
                  <div className="flex flex-row gap-[50px] items-center max-sm:flex-col max-sm:gap-[20px]">
                    <div className="flex items-center w-[250px] h-[24px] max-sm:w-[100%] max-sm:items-start">
                      <p className="text-black font-Jost text-[18px] font-normal">{donation.TransactionDate}</p>
                    </div>
                    <div className="flex items-center w-[250px] h-[49px] max-sm:w-[100%] max-sm:items-start">
                      <p className="font-Jost text-lg font-medium text-[#0E5C57] cursor-pointer line-clamp-1-5">{donation.Transaction_Name}</p>
                    </div>
                    <div className="flex flex-col items-center w-[300px] h-[48px] text-center max-sm:w-[100%] max-sm:items-start">
                      <p className="text-black font-Jost text-[18px] font-normal">{donation.Transaction_Amount}</p>
                      <p className="text-[18px] text-black-400 font-Jost text-sm">{donation.PaymentStatus}</p>
                    </div>
                    <div className="w-[250px] h-[24px] max-sm:w-[100%]">
                      <p className="text-black-400 text-[18px] font-Jost text-sm">{donation.Frequency}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-10">No history found.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default RecurPlanDetails;
